<template>
  <div class="modal-wrapper">
    <div class="csv-modal">
      <div v-if="!isUploaded && !isLoading">
        <div v-if="!isValid" class="validation-info">
          <img :src="require('@/assets/red-info-alert.svg')" />
          Invalid file format. Please upload a CSV file.
        </div>
        <div class="title">Import CSV</div>
        <div class="upload-info">
          Upload CSV file to fix any booking issues. You can download a sample
          file to ensure your file matchs our CSV file format.
        </div>
        <div class="download-sample">Download Sample File</div>
        <div class="drag-zone" v-if="files.length === 0">
          <Vue2Dropzone
            id="dropzone"
            :includeStyling="false"
            :options="dropzoneOptions"
            useCustomSlot
            @vdropzone-file-added="fileAdded"
          >
            <div>Drag and drop to upload CSV files</div>
            <div class="alternative-info">or</div>
            <button class="upload-button">Select files to upload</button>
          </Vue2Dropzone>
        </div>
        <div v-else class="file-zone">
          <div
            v-for="(file, index) in files"
            class="files-ready"
            :key="`file_to_upload_${index}`"
          >
            <div class="file-information-wrapper">
              <div>
                <img :src="require('@/assets/csv-icon.svg')" />
              </div>
              <div>
                <div>
                  {{ file.name }}
                </div>
                <div>
                  {{ file.size }}
                </div>
              </div>
            </div>
            <div class="uploaded-btn-wrapper">
              <div>
                <img :src="require('@/assets/green-circle-check.svg')" />
              </div>
              <div @click="removeFile(file)">
                <img :src="require('@/assets/red-trash-icon.svg')" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="cancel-button">Cancel</button>
          <button @click="doImport" class="import-button">Import</button>
        </div>
      </div>
      <div v-else-if="isLoading">
        <div class="progress-number">{{ value }}%</div>
        <progress-bar :options="options" :value="value" />
        <div class="progress-info">
          Please wait while your bookings are importing
        </div>
        <div class="center-btn">
          <button @click="closeModal" class="cancel-button">Cancel</button>
        </div>
      </div>
      <div v-else>
        <div class="title">Import Review</div>
        <div class="upload-status">
          <div class="bookings-info">
            <div>Bookings added</div>
            <div class="count-result">{{ bookingsUpdated }}</div>
          </div>
          <div class="bookings-info">
            <div>Bookings removed</div>
            <div class="count-result">{{ bookingsRemoved }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="import-button">Accept</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from '../../Firebase'
import Vue from 'vue'
import Vue2Dropzone from 'vue2-dropzone'
import ProgressBar from 'vuejs-progress-bar'
import axios from 'axios'

Vue.use(ProgressBar)

export default {
  name: 'UploadCSVModal',
  components: {
    Vue2Dropzone
  },
  data() {
    return {
      isValid: true,
      isUploaded: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        autoProcessQueue: false
      },
      bookingsUpdated: 0,
      bookingsRemoved: 0,
      files: [],
      isLoading: false,
      value: 60,
      options: {
        layout: {
          height: 32,
          width: 448,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        },
        text: {
          hideText: true
        },
        progress: {
          color: '#66B015',
          backgroundColor: '#F5F6FA',
          inverted: false
        }
      }
    }
  },
  methods: {
    fileAdded(file) {
      this.files.push(file)
      this.doValidation()
      if (!this.isValid) {
        this.removeFile(file)
      }
    },
    removeFile(file) {
      const index = this.files.findIndex(
        (a) => a.upload.uuid === file.upload.uuid
      )
      if (index !== -1) {
        this.files.splice(index, 1)
      }
    },
    closeModal() {
      this.$emit('closeModal')
    },
    async postFiles() {
      const file = this.files[0]
      var data = []
      const myPromise = new Promise((resolve) => {
        this.$papa.parse(file, {
          complete: async function (results) {
            for (let index = 0; index < results.data.length; index++) {
              const element = results.data[index]
              const rowData = {
                confirmationCode: element[0],
                status: element[1],
                guestName: element[2],
                contact: element[3],
                adultNumber: element[4],
                childrenNumber: element[5],
                infantNumber: element[6],
                startDate: element[7],
                endDate: element[8],
                nightsNumber: element[9],
                bookedDate: element[10],
                listing: element[11],
                earnings: element[12]
              }
              if (index != 0) {
                data.push(rowData)
              }
            }
            try {
              let syncResult = await axios.post(
                'https://rentalios-management-helxajom3a-uc.a.run.app/api/rooms/csv?key=' +
                  auth.currentUser.Aa +
                  '&email=' +
                  auth.currentUser.email,
                { csv: data },
                {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }
              )
              this.bookingsUpdated = syncResult.bookingsUpdated
              this.bookingsRemoved = syncResult.bookingsRemoved
              resolve(true)
            } catch {
              resolve(false)
            }
          }
        })
      })
      const result = await myPromise
      if (result) {
        this.isUploaded = true
        this.isLoading = false
      } else {
        this.isUploaded = false
        this.isLoading = false
        this.$notify({
          group: 'rent-mgt-notification',
          type: 'error',
          text: 'Error While Importing CSV'
        })
      }
    },
    async doImport() {
      this.isLoading = true
      await this.postFiles()
    },
    doValidation() {
      this.isValid = true
      for (let i = 0; i < this.files.length; i++) {
        const current = this.files[i]
        if (current.type !== 'text/csv') {
          this.isValid = false
          return
        }
      }
    }
  }
}
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  z-index: 15;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
}
.csv-modal {
  background-color: #ffffff;
  max-width: 448px;
  margin: 1.75rem auto;
  text-align: left;
  box-shadow: 0px 4px 20px rgba(43, 45, 55, 0.1);
  border-radius: 4px;
  padding: 24px;
}
.title {
  color: #66b015;
  font-weight: 700;
  font-size: 17px;
  margin-bottom: 16px;
}
.upload-info {
  font-weight: 400;
  font-size: 15px;
  color: #4a4a4a;
  margin-bottom: 16px;
}
.download-sample {
  font-weight: 600;
  font-size: 15px;
  text-decoration-line: underline;
  color: #00530d;
  cursor: pointer;
  margin-bottom: 16px;
}
.drag-zone {
  font-weight: 400;
  font-size: 17px;
  background: #f5f6fa;
  border: 1px dashed #4a4a4a;
  border-radius: 5px;
  text-align: center;
  padding: 24px 0;
}
.upload-button {
  font-weight: 400;
  font-size: 17px;
  background: #38383a;
  border: 1px solid #38383a;
  border-radius: 5px;
  color: #ffffff;
  padding: 10px 18px;
  cursor: pointer;
}
.cancel-button {
  font-weight: 400;
  font-size: 15px;
  color: #66b015;
  border: 1px solid #66b015;
  border-radius: 4px;
  background-color: #ffffff;
  padding: 12px 0;
  width: 123px;
  cursor: pointer;
}
.import-button {
  font-weight: 600;
  font-size: 15px;
  color: #ffffff;
  background-color: #66b015;
  border: 1px solid #66b015;
  border-radius: 4px;
  padding: 12px 0;
  width: 123px;
  cursor: pointer;
}
.alternative-info {
  margin: 8px 0;
}
.modal-footer {
  display: flex;
  margin: 24px 0 0 0;
  align-items: center;
  gap: 8px;
  justify-content: end;
}
.validation-info {
  display: flex;
  align-items: center;
  background: rgba(223, 0, 15, 0.05);
  border-radius: 6px;
  padding: 12px 18px;
  color: #df000f;
  font-weight: 600;
  font-size: 16px;
  gap: 12px;
  margin-bottom: 24px;
}
.files-ready {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.uploaded-btn-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}
.file-information-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
}
.progress-number {
  text-align: center;
  font-weight: 700;
  font-size: 27px;
  color: #66b015;
  margin-bottom: 8px;
}
.progress-info {
  font-weight: 400;
  font-size: 15px;
  text-align: center;
  color: #4a4a4a;
  margin: 18px 0;
}
.center-btn {
  text-align: center;
}
::v-deep .dz-preview.dz-image-preview {
  display: none;
}
::v-deep .dz-preview.dz-file-preview {
  display: none;
}
.bookings-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: solid 0.5px #38383a;
  border-bottom: solid 0.5px #38383a;
  padding: 12px;
}
.count-result {
  font-weight: 800;
  font-size: 24px;
}
</style>
